import { AfterViewChecked, ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { QuestionnaireService } from '../services/questionnaire.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { AbstractControl, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { data } from '../../israel-cities';
import { SystemTablesService } from "../services/system-tables.service";
import { Draft } from '../services/draft.service';
import { TranslateService } from '@ngx-translate/core';

export interface cityData {
	semel_yeshuv: string,
	name: string,
	english_name: string,
	semel_napa: string,
	shem_napa: string,
	semel_lishkat_mana: string,
	lishka: string,
	semel_moatza_ezorit: string,
	shem_moaatza: string
}

@Component({
	selector: 'app-property-details',
	templateUrl: './property-details.component.html',
	styleUrls: ['./property-details.component.scss']
})
export class PropertyDetailsComponent implements OnInit, AfterViewChecked, AfterViewChecked {
	private route$: Subscription;
	qID: any;
	prevQID: any;
	visibleQids;
	editQuestion;
	currentStepName;
	currentStep;
	propertyDetails: FormGroup;
	inWhichCity: FormControl;
	submitted;
	filteredCities: Observable<cityData[]>;
	DATA: any = data;
	cities;
	warnInfo = false;
	submitQID;
	defaultValue = "";
	timeCombo: string[] = ["בחודש הקרוב", "עד 3 חודשים", "מעל 3 חודשים", "אין עדיין מועד"];
	myControl: FormControl = new FormControl();
	isEdit;

	selectedOption: boolean = false;
	inputClicked: boolean = false;

	qFields = {
		1: [{ name: "inWhichCity", validators: [Validators.required, this.isInList()], systemTable: "stringTable", numberSystemTable: ["1216"] }],
		2: [{ name: "propertyValue", validators: [Validators.required, this.amountValidatorQ2()] }],
		3: [
			{ name: "stadiumValue", validators: [Validators.required] },
			{ name: "constructionCost", validators: [Validators.required] }
		],
		'3.1': [{ name: "isYourField", validators: [Validators.required] }],
		'3.2': [{ name: "isPlanToBuildOnTheField", validators: [Validators.required] }],
		'3.3': [{ name: "buildCost", validators: [Validators.required] }],
		4: [{ name: "isPropertyMortgaged", validators: [Validators.required] }],
		5: [{ name: "isContractSigned", validators: [Validators.required] }],
		6: [{ name: "timeMortgageMoney", validators: [Validators.required] }],
	};

	constructor(
		private questionnaireService: QuestionnaireService,
		private activeRoute: ActivatedRoute,
		private fb: FormBuilder,
		private draft: Draft,
		private systemTablesService: SystemTablesService,
		private _changeDetector: ChangeDetectorRef,
		private translate: TranslateService
	) { }


	ngOnInit() {
		console.log('systemTablesService', this.systemTablesService);
		this.cities = this.systemTablesService.getTable('1216')

		this.currentStep = this.questionnaireService.getStep("property-details");
		this.inWhichCity = new FormControl(this.questionnaireService.getQuestion(this.currentStep, "1").answer.fields[0].answerValue)
		this.createForm();

		this.route$ = this.activeRoute.params.subscribe(params => {
			console.log("-----------------------------> params", params);
			this.prevQID = this.qID;
			this.qID = params.qid;
			this.editQuestion = null;
			this.currentStepName = "property-details";

			if (params.qid === "all") {
				this.isEdit = true;
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
				this.questionnaireService.clearAllQuestionValidators(this.propertyDetails.controls, this.qFields);
			} else {
				this.isEdit = false;
				this.setValidators();
				this.visibleQids = this.questionnaireService.getAnsweredQuestionsForStep(this.currentStep);
			}

			this.setFocusFirstComponent(this.qID);
		});
		if (this.draft.autoForm) {
			this.propertyDetails = this.draft.buildForm(this.currentStep, this.propertyDetails);
		}

		// console.log("GAL---->inWhichCity", this.inWhichCity)
	}

	ngAfterViewInit() {
		// this.setFocusFirstComponent('1');
		// console.log('ngAfterViewInit...')
		this.focusToElement(`input[aria-label="${this.translate.instant('PROPERTY_DETAILS.Q1.PH1')}"]`);
	}

	private setFocusFirstComponent(qID) {
		if (qID === '1') {
			// this.focusToElement(`input[aria-label="${this.translate.instant('PROPERTY_DETAILS.Q1.PH1')}"]`);
		} else if (qID === '2') {
			// this.focusToElement(`input[aria-label="${this.translate.instant('PROPERTY_DETAILS.Q2.PH1')}"]`);
		} else if (qID === '3') {
			// this.focusToElement(`input[aria-label="${this.translate.instant('PROPERTY_DETAILS.Q3.PH1')}"]`);
		} else if (qID === '3.1') {
			this.focusToElement(`label[data-id="qID3.1a"`);
		} else if (qID === '3.2') {
			this.focusToElement(`label[data-id="qID3.2a"`);
		} else if (qID === '3.3') {
			// this.focusToElement(`input[aria-label="${this.translate.instant('PROPERTY_DETAILS.Q3_3.PH1')}"]`);
		} else if (qID === '4') {
			this.focusToElement(`label[data-id="qID4a"`);
		} else if (qID === '5') {
			this.focusToElement(`label[data-id="qID5a"`);
		} else if (qID === '6') {
			this.focusToElement(`div[aria-label="${this.translate.instant('PROPERTY_DETAILS.Q6')}"]`);
		}
	}

	createForm() {
		this.propertyDetails = this.fb.group({
			inWhichCity: this.inWhichCity,
			propertyValue: this.questionnaireService.getQuestion(this.currentStep, "2").answer.fields[0].answerValue,
			stadiumValue: this.questionnaireService.getQuestion(this.currentStep, "3").answer.fields[0].answerValue,
			constructionCost: this.questionnaireService.getQuestion(this.currentStep, "3").answer.fields[1].answerValue,
			isYourField: this.questionnaireService.getQuestion(this.currentStep, "3.1").selectedAnswer,
			isPlanToBuildOnTheField: this.questionnaireService.getQuestion(this.currentStep, "3.2").selectedAnswer,
			buildCost: this.questionnaireService.getQuestion(this.currentStep, "3.3").answer.fields[0].answerValue,
			isPropertyMortgaged: this.questionnaireService.getQuestion(this.currentStep, "4").selectedAnswer,
			isContractSigned: this.questionnaireService.getQuestion(this.currentStep, "5").selectedAnswer,
			timeMortgageMoney: this.questionnaireService.getQuestion(this.currentStep, "6").answer.fields[0].answerValue

		});
	}

	setValidators() {

		this.clearPreviousQuestionValidators();

		for (let i = 0; i < this.qFields[this.qID].length; i++) {
			let field = this.qFields[this.qID][i];
			this.propertyDetails.controls[field.name].setValidators(field.validators);
			this.propertyDetails.controls[field.name].updateValueAndValidity();
		}
		if (this.qID === "3") {
			this.propertyDetails.setValidators(this.amountValidatorQ3('stadiumValue', 'constructionCost'));
			this.propertyDetails.updateValueAndValidity();
		}
		this.submitted = false;
	}

	clearPreviousQuestionValidators() {
		let keys = Object.keys(this.qFields);
		this.propertyDetails.setValidators(null);
		this.propertyDetails.updateValueAndValidity();
		for (let i = 0; i < keys.length; i++) {
			for (let j = 0; j < this.qFields[keys[i]].length; j++) {
				this.propertyDetails.controls[this.qFields[keys[i]][j].name].setValidators(null);
				this.propertyDetails.controls[this.qFields[keys[i]][j].name].updateValueAndValidity();
			}
		}
	}

	nextClick(qID, answers) {
		if (answers) {
			this.questionnaireService.saveAndNavigate(this.currentStep, qID, answers);
		}
	}

	@HostListener('window:keydown', ['$event'])
	keyEvent(event: KeyboardEvent): any {
		if (event.key === 'Enter') {
			if ((event.target as HTMLElement).dataset.fieldname === 'isYourField' ||
				(event.target as HTMLElement).dataset.fieldname === 'isPlanToBuildOnTheField' ||
				(event.target as HTMLElement).dataset.fieldname === 'isPropertyMortgaged' ||
				(event.target as HTMLElement).dataset.fieldname === 'isContractSigned') {
				this.propertyDetails.controls[(event.target as HTMLElement).dataset.fieldname].setValue((event.target as HTMLElement).dataset.fieldvalue);
				this.onSubmit(this.propertyDetails);
			}

		}
	}

	onSubmit({ value, valid }: { value: any, valid: boolean }) {
		console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>  onSubmit(): isvalid=", valid, "value", value);
		this.submitted = true;
		if (!valid) {
			this.questionnaireService.submitForm(true);
		}
		else {
			this.questionnaireService.submitForm(false);
		}
		if (valid) {


			let q;
			this.submitQID = (this.qID !== "all") ? this.qID : this.editQuestion;

			q = this.qFields[this.submitQID];

			let values = q.map(r => {
				return value[r.name];
			});

			let valueTmp = JSON.parse(JSON.stringify(value));
			this.setCitiesCode(valueTmp);
			if (this.submitQID === "5") {
				this.draft.IsContractSigned = valueTmp["isContractSigned"];
			}
			this.draft.buildArrDraft(this.submitQID, this.qFields, valueTmp, this.currentStep, this.isEdit)
			this.questionnaireService.sendGA(this.currentStep, this.qID, values);

			this.nextClick(this.submitQID, values);
		}
	}

	private setCitiesCode(valueTmp) {
		if (this.submitQID === "1") {
			let city = this.cities.find(v => v.name === valueTmp["inWhichCity"]).code;
			valueTmp["inWhichCity"] = city;
		}
	}

	editQuestionChange(qid) {
		this.qID = qid;
		this.setValidators();
	}

	isInList() {
		return (control: AbstractControl): { [key: string]: any } => {
			if (control.value.length > 0) {
				let cityBingo = this.cities.filter(city => city.name === control.value);
				if (cityBingo.length < 1) {
					return { isNotInList: true };
				}
				else return null;
			}
		}
	}

	amountValidatorQ3(stadiumValue, constructionCost) {
		return (group: FormGroup): { [key: string]: any } => {
			this.warnInfo = false;
			let maxAmount = 0;
			let getQuestion = this.questionnaireService.getQuestion;
			let step2 = this.questionnaireService.getStepByID("2");
			let loanDetailsStep2Question1Answer = (getQuestion(step2, "1").selectedAnswer[0]);//matara aalvaa
			let loanDetailsStep2Question2Answer = (+(getQuestion(step2, "2").answer.fields[0].answerValue));//shoum amashkenta
			let loanDetailsStep2Question3Answer = (getQuestion(step2, "3").selectedAnswer[0]);//dira hiloufit
			let loanDetailsStep2Question4Answer = (getQuestion(step2, "4").selectedAnswer[0]);//keneged nehess kayam
			let loanDetailsStep2Question5Answer = (getQuestion(step2, "5").selectedAnswer[0]);//mitkaven limkor et anehess
			let currentStepQuestion3Answer = group.controls['stadiumValue'].value + group.controls['constructionCost'].value;//shovi migrach+alout binya

			if ((loanDetailsStep2Question1Answer === "1" || loanDetailsStep2Question1Answer === "2" || loanDetailsStep2Question1Answer === "17" || loanDetailsStep2Question1Answer === "7") && loanDetailsStep2Question3Answer === "NO") {
				maxAmount = 0.75;
			}
			if ((loanDetailsStep2Question1Answer === "1" || loanDetailsStep2Question1Answer === "2") && loanDetailsStep2Question3Answer === "YES" && loanDetailsStep2Question4Answer === "YES" && loanDetailsStep2Question5Answer === "YES") {
				maxAmount = 0.70;
			}
			if ((loanDetailsStep2Question1Answer === "5" || loanDetailsStep2Question1Answer === "10") && loanDetailsStep2Question3Answer === "NO") {
				maxAmount = 0.70;
			}
			if ((loanDetailsStep2Question1Answer === "1" || loanDetailsStep2Question1Answer === "2" || loanDetailsStep2Question1Answer === "5" || loanDetailsStep2Question1Answer === "10") && loanDetailsStep2Question3Answer === "YES" && loanDetailsStep2Question4Answer === "YES" && loanDetailsStep2Question5Answer === "NO") {
				maxAmount = 0.50;
			}
			if ((loanDetailsStep2Question1Answer === "17" || loanDetailsStep2Question1Answer === "7") && loanDetailsStep2Question3Answer === "YES" && loanDetailsStep2Question4Answer === "YES") {
				maxAmount = 0.50;
			}
			if (loanDetailsStep2Question1Answer === "11") {
				maxAmount = 0.50;
			}

			if ((loanDetailsStep2Question1Answer === "1" || loanDetailsStep2Question1Answer === "2" || loanDetailsStep2Question1Answer === "17" || loanDetailsStep2Question1Answer === "7") && loanDetailsStep2Question3Answer === "YES" && loanDetailsStep2Question4Answer === "NO") {
				maxAmount = 0.75;
			}
			if ((loanDetailsStep2Question1Answer === "1" || loanDetailsStep2Question1Answer === "2") && loanDetailsStep2Question3Answer === "YES" && loanDetailsStep2Question4Answer === "NO") {
				maxAmount = 0.75;
			}
			if ((loanDetailsStep2Question1Answer === "5" || loanDetailsStep2Question1Answer === "10") && loanDetailsStep2Question3Answer === "YES" && loanDetailsStep2Question4Answer === "NO") {
				maxAmount = 0.70;
			}

			let result = loanDetailsStep2Question2Answer / currentStepQuestion3Answer;


			if (result > maxAmount) {
				switch (maxAmount) {
					case 0.75:
						return { amountValidator75: true };
					case 0.70:
						return { amountValidator70: true };
					case 0.50:
						return { amountValidator50: true };
					default:
						break;
				}

			} else {
				//this.warnInfo = true;
				return null;
			}
			//return null;
		}
	}

	filterCities(name: any) {
		console.log("GAL---->filterCities name", name);

		return this.cities.filter(city =>
			city.name.toLowerCase().indexOf(name.toLowerCase()) === 0);
	}

	amountValidatorQ2() {
		return (control: AbstractControl): { [key: string]: any } => {
			this.warnInfo = false;
			let maxAmount = 0;
			let getQuestion = this.questionnaireService.getQuestion;
			let step2 = this.questionnaireService.getStepByID("2");
			let loanDetailsStep2Question1Answer = (getQuestion(step2, "1").selectedAnswer[0]);//matara aalvaa
			let loanDetailsStep2Question2Answer = (+(getQuestion(step2, "2").answer.fields[0].answerValue));//shoum amashkenta
			let loanDetailsStep2Question3Answer = (getQuestion(step2, "3").selectedAnswer[0]);//dira hiloufit
			let loanDetailsStep2Question4Answer = (getQuestion(step2, "4").selectedAnswer[0]);//keneged nehess kayam
			let loanDetailsStep2Question5Answer = (getQuestion(step2, "5").selectedAnswer[0]);//mitkaven limkor et anehess
			let currentStepQuestion3Answer = +control.value;//chover anehess

			//old logic do not remove
			// if (loanDetailsStep2Question3Answer === "NO") {
			// 	maxAmount = 0.75;
			// }
			// else if (loanDetailsStep2Question1Answer === "11") {
			// 	maxAmount = 0.50;
			// }
			// else if (loanDetailsStep2Question3Answer === "YES" && loanDetailsStep2Question4Answer === "YES" && loanDetailsStep2Question5Answer === "YES") {
			// 	maxAmount = 0.70;
			// }
			// else if (loanDetailsStep2Question3Answer === "YES" && loanDetailsStep2Question4Answer === "YES" && loanDetailsStep2Question5Answer === "NO") {
			// 	maxAmount = 0.50;
			// }
			// else if (loanDetailsStep2Question3Answer === "YES" && loanDetailsStep2Question4Answer === "YES" && (loanDetailsStep2Question1Answer === "1" || loanDetailsStep2Question1Answer === "2" || loanDetailsStep2Question1Answer === "10" || loanDetailsStep2Question1Answer === "11")) {
			// 	maxAmount = 0.50;
			// }

			if ((loanDetailsStep2Question1Answer === "1" || loanDetailsStep2Question1Answer === "2" || loanDetailsStep2Question1Answer === "17" || loanDetailsStep2Question1Answer === "7") && loanDetailsStep2Question3Answer === "NO") {
				maxAmount = 0.75;
			}
			if ((loanDetailsStep2Question1Answer === "1" || loanDetailsStep2Question1Answer === "2") && loanDetailsStep2Question3Answer === "YES" && loanDetailsStep2Question4Answer === "YES" && loanDetailsStep2Question5Answer === "YES") {
				maxAmount = 0.70;
			}
			if ((loanDetailsStep2Question1Answer === "5" || loanDetailsStep2Question1Answer === "10") && loanDetailsStep2Question3Answer === "NO") {
				maxAmount = 0.70;
			}
			if ((loanDetailsStep2Question1Answer === "1" || loanDetailsStep2Question1Answer === "2" || loanDetailsStep2Question1Answer === "5" || loanDetailsStep2Question1Answer === "10") && loanDetailsStep2Question3Answer === "YES" && loanDetailsStep2Question4Answer === "YES" && loanDetailsStep2Question5Answer === "NO") {
				maxAmount = 0.50;
			}
			if ((loanDetailsStep2Question1Answer === "17" || loanDetailsStep2Question1Answer === "7") && loanDetailsStep2Question3Answer === "YES" && loanDetailsStep2Question4Answer === "YES") {
				maxAmount = 0.50;
			}
			if (loanDetailsStep2Question1Answer === "11") {
				maxAmount = 0.50;
			}

			if ((loanDetailsStep2Question1Answer === "1" || loanDetailsStep2Question1Answer === "2" || loanDetailsStep2Question1Answer === "17" || loanDetailsStep2Question1Answer === "7") && loanDetailsStep2Question3Answer === "YES" && loanDetailsStep2Question4Answer === "NO") {
				maxAmount = 0.75;
			}
			if ((loanDetailsStep2Question1Answer === "1" || loanDetailsStep2Question1Answer === "2") && loanDetailsStep2Question3Answer === "YES" && loanDetailsStep2Question4Answer === "NO") {
				maxAmount = 0.75;
			}
			if ((loanDetailsStep2Question1Answer === "5" || loanDetailsStep2Question1Answer === "10") && loanDetailsStep2Question3Answer === "YES" && loanDetailsStep2Question4Answer === "NO") {
				maxAmount = 0.70;
			}

			let result = loanDetailsStep2Question2Answer / currentStepQuestion3Answer;

			if (result > maxAmount) {
				switch (maxAmount) {
					case 0.75:
						return { amountValidator75: true };
					case 0.70:
						return { amountValidator70: true };
					case 0.50:
						return { amountValidator50: true };
					default:
						break;
				}

			} else {
				//this.warnInfo = true;
				return null;
			}
			//return null;
		}
	}
	onSelectionChange(event) {
		if (event) {
			console.log("GAL--->onSelectionChange", event)
			this.selectedOption = true
		}
	}

	ngAfterViewChecked(): void {
		if (!this._changeDetector['destroyed']) {
			this._changeDetector.detectChanges();
		}
	}

	focusToElement(selector: string) {
		const selectedElement = Array.from(document.querySelectorAll(selector));

		if (selectedElement && selectedElement.length > 0) {
			const nowActiveElement = document.activeElement;
			(nowActiveElement as HTMLElement).blur();
			setTimeout(() => (selectedElement[0] as HTMLElement).focus(), 0);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/property-details/property-details.component.ts